import { motion } from 'framer-motion';
import { MENU } from './data';

// CARTE — printed-menu layout. Type-only, NO product cards. Course-by-course.
// Each dish is a single line: name (italics) ... origin note ... price.
export default function Carte() {
  return (
    <div className="bg-[#F1ECDF] text-[#0A0A0A]">
      <section className="pt-12 pb-8 max-w-[1300px] mx-auto px-8 lg:px-14 border-b-2 border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D4A] mb-4">— La carte · printemps 2026</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.95] text-[#4A5638]">À <span className="italic text-[#6B2D4A]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>table</span>.</h1>
        <p className="font-serif italic text-base lg:text-lg text-[#0A0A0A]/60 mt-4 max-w-2xl">Menu changes mensuellement. Plats marqués <span className="font-mono text-[#4A5638]">V</span> sont végétariens. Légumes du jour selon le marché.</p>
      </section>

      {/* Course-by-course menu */}
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-16 space-y-16">
        {MENU.map((c, i) => (
          <motion.div key={c.course} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}>
            <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D4A] mb-2">— Acte {['I', 'II', 'III', 'IV'][i]}</p>
            <h2 className="font-serif italic text-4xl lg:text-6xl text-[#4A5638]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>{c.course}</h2>
            <div className="border-t border-dashed border-[#0A0A0A]/30 mt-6">
              {c.items.map((it, j) => (
                <div key={j} className="grid grid-cols-[1fr_auto] items-baseline gap-6 py-5 border-b border-dashed border-[#0A0A0A]/15">
                  <div>
                    <p className="font-serif text-xl lg:text-2xl text-[#0A0A0A] leading-tight" dangerouslySetInnerHTML={{ __html: it.t + (it.n ? ` <span class="font-mono text-[10px] tracking-[0.2em] text-[#4A5638] ml-2">${it.n}</span>` : '') }} />
                    {it.src && <p className="font-serif italic text-sm text-[#0A0A0A]/55 mt-1" dangerouslySetInnerHTML={{ __html: '— ' + it.src }} />}
                  </div>
                  <div className="font-serif text-2xl text-[#6B2D4A]" data-testid={`resto-dish-price-${i}-${j}`}>{it.p}€</div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </section>

      {/* Wine pairing note */}
      <section className="bg-[#6B2D4A] text-[#F1ECDF] py-16">
        <div className="max-w-[820px] mx-auto px-8 lg:px-14 text-center">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#E0C77A] mb-4">— Accord mets-vins, sur demande</p>
          <p className="font-serif italic text-2xl lg:text-3xl leading-[1.4]">Cinq verres, choisis par Camille pour suivre votre menu, <span style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>+ 48€</span>.</p>
        </div>
      </section>
    </div>
  );
}
